(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/hooks/use-personal-results-team.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/hooks/use-personal-results-team.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect;
const FetchState = svs.components.marketplaceCompetition.constants.FetchState;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const fetchPersonalResultsAction = svs.components.marketplaceCompetition.services.actions.personalResultActions.fetchPersonalResultsAction;
const selectPersonalResults = svs.components.marketplaceCompetition.services.selectors.personalResultSelectors.selectPersonalResults;

const usePersonalResultsTeam = (competitionId, teamId) => {
  var _competitionResult$te;
  const dispatch = useDispatch();
  const competitionResult = useSelector(state => selectPersonalResults(state, competitionId));
  const teamResult = (_competitionResult$te = competitionResult.teams[teamId]) !== null && _competitionResult$te !== void 0 ? _competitionResult$te : undefined;
  useEffect(() => {
    if (!teamResult && (teamResult === null || teamResult === void 0 ? void 0 : teamResult.status) !== FetchState.Pending) {
      const teamIds = [teamId];
      const shouldFetchIndividualResults = false;
      dispatch(fetchPersonalResultsAction({
        competitionId,
        teamIds,
        shouldFetchIndividualResults
      }));
    }
  }, [teamResult, competitionId, teamId, dispatch]);
  return teamResult;
};
setGlobal('svs.components.marketplaceCompetition.services.hooks.usePersonalResultsTeam', usePersonalResultsTeam);

 })(window);